/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Published
 *
 * 1 = NotPublished
 *
 * 2 = Capped
 *
 * 3 = Rejected
 */
export enum AutotraderAdvertStatusEnum {
  Published = 0,
  NotPublished = 1,
  Capped = 2,
  Rejected = 3,
}
